/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for MailTemplateResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetMailTemplateByIdResponse, GetMailTemplatesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class MailTemplateResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getMailTemplateById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetMailTemplateByIdResponse, unknown> & { defaultValue: NoInfer<GetMailTemplateByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetMailTemplateByIdResponse>;
    getMailTemplateById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetMailTemplateByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetMailTemplateByIdResponse | undefined>;
    getMailTemplateById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetMailTemplateByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetMailTemplateByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/MailTemplate/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getMailTemplates(searchTerm: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetMailTemplatesResponse, unknown> & { defaultValue: NoInfer<GetMailTemplatesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetMailTemplatesResponse>;
    getMailTemplates(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetMailTemplatesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetMailTemplatesResponse | undefined>;
    getMailTemplates(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetMailTemplatesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetMailTemplatesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            return {
                url: `${this.basePath}/MailTemplate`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
